
import React from 'react';
import { Check, X } from 'lucide-react';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '@/components/ui/table';
import { Card } from '@/components/ui/card';

const EscortServicesTiers: React.FC = () => {
  const services = [
    {
      name: 'Statut vérifié',
      essential: true,
      premium: true,
      elite: true,
      description: 'Badge de profil vérifié après KYC'
    },
    {
      name: 'Option "Unvisible"',
      essential: true,
      premium: true,
      elite: true,
      description: 'Visibilité limitée aux membres payants'
    },
    {
      name: 'Traduction automatique',
      essential: true,
      premium: true,
      elite: true,
      description: 'Profil traduit dans toutes les langues'
    },
    {
      name: 'Création de contenu IA',
      essential: true,
      premium: true,
      elite: true,
      description: 'Assistance par IA pour vos descriptions'
    },
    {
      name: 'Mise en avant basique',
      essential: true,
      premium: true,
      elite: true,
      description: 'Visibilité accrue pendant heures creuses'
    },
    {
      name: 'Support client standard',
      essential: true,
      premium: false,
      elite: false,
      description: 'Assistance par email'
    },
    {
      name: 'Mise en avant avancée',
      essential: false,
      premium: true,
      elite: true,
      description: 'Priorité dans les recherches aux heures de pointe'
    },
    {
      name: 'Vente de médias privés',
      essential: false,
      premium: true,
      elite: true,
      description: 'Vente de photos, vidéos ou contenus exclusifs'
    },
    {
      name: 'Gestion des prospects',
      essential: false,
      premium: true,
      elite: true,
      description: 'IA pour filtrer et répondre aux demandes'
    },
    {
      name: 'Prise de rendez-vous',
      essential: false,
      premium: true,
      elite: true,
      description: 'Système intégré à votre agenda'
    },
    {
      name: 'Support client prioritaire',
      essential: false,
      premium: true,
      elite: false,
      description: 'Assistance rapide via chat'
    },
    {
      name: 'Mise en avant premium',
      essential: false,
      premium: false,
      elite: true,
      description: 'Placement en tête des recherches'
    },
    {
      name: 'Échanges vocaux IA',
      essential: false,
      premium: false,
      elite: true,
      description: 'Abonnement pour échanges vocaux automatisés'
    },
    {
      name: 'Panic button',
      essential: false,
      premium: false,
      elite: true,
      description: 'Bouton d\'urgence pour alertes'
    },
    {
      name: 'Analyse de données',
      essential: false,
      premium: false,
      elite: true,
      description: 'Statistiques sur les performances'
    },
    {
      name: 'Support client VIP',
      essential: false,
      premium: false,
      elite: true,
      description: 'Assistance prioritaire 24/7'
    }
  ];

  return (
    <Card className="bg-white shadow-md border-0 overflow-hidden">
      <div className="rounded-md overflow-hidden">
        <Table>
          <TableHeader className="bg-muted/50">
            <TableRow>
              <TableHead className="w-1/3 font-bold text-black">Service</TableHead>
              <TableHead className="w-1/6 text-center font-bold text-black">Essentiel</TableHead>
              <TableHead className="w-1/6 text-center font-bold text-black">Premium</TableHead>
              <TableHead className="w-1/6 text-center font-bold text-black">Élite</TableHead>
              <TableHead className="w-1/3 font-bold text-black">Description</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {services.map((service, index) => (
              <TableRow key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-muted/10'}>
                <TableCell className="font-medium">
                  {service.name}
                </TableCell>
                <TableCell className="text-center">
                  {service.essential ? (
                    <Check className="mx-auto h-5 w-5 text-green-500" />
                  ) : (
                    <X className="mx-auto h-5 w-5 text-pink-200" />
                  )}
                </TableCell>
                <TableCell className="text-center">
                  {service.premium ? (
                    <Check className="mx-auto h-5 w-5 text-green-500" />
                  ) : (
                    <X className="mx-auto h-5 w-5 text-pink-200" />
                  )}
                </TableCell>
                <TableCell className="text-center">
                  {service.elite ? (
                    <Check className="mx-auto h-5 w-5 text-green-500" />
                  ) : (
                    <X className="mx-auto h-5 w-5 text-pink-200" />
                  )}
                </TableCell>
                <TableCell className="text-sm text-muted-foreground">
                  {service.description}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
};

export default EscortServicesTiers;
